// d:/.../src/components/ListaCategoria/styles.ts
import styled, { createGlobalStyle } from "styled-components";

export const Container = styled.div`
  width: 100%;
`;

export const Tools = styled.div`
  width: 100%;
  /* Remova as linhas abaixo */
  margin-bottom: 3vh;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  // Use gap para espaçamento entre os itens
  gap: 16px; 
`;

export const LeftContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
`;

export const DivTable = styled.div`
  height: 610px;
  width: 100%;
  margin: 0 auto; /* Centraliza a div horizontalmente */

  .ant-btn {
    /* Se precisar de algum estilo específico para botões, adicione aqui */
  }

  .ant-table-cell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ant-form-item {
    margin-bottom: 0;
  }
`;
export const ContainerImage = styled.div`
  width: fit-content;
  img{
    width: 160px;
  }
  span{
    margin-left: 20px;
    font-size: 0.8rem;
    font-weight: 700;
  }
`

export const MenuContainer = styled.div`
  width: fit-content;
  span{
    font-size: 0.8rem;
    font-weight: 700;
  }
`
export const ContainerWord = styled.div`
  margin-right: auto;
  margin-left: auto;
  width: fit-content;
  font-weight: 700;
  font-size: 24px;

`

export const RoundedModalStyle = createGlobalStyle`
  .ant-modal-wrap.my-custom-rounded-modal .ant-modal-content {
    border-radius: 12px;
    overflow: hidden; /* Garante que o conteúdo não vaze das bordas arredondadas */
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 32px 48px 0 rgba(0, 0, 0, 0.35);
    backdrop-filter: blur(7px);
    border: 1px solid rgba(255, 255, 255, 0.08);
  }
`;

export const EmpresaDropdownStyle = createGlobalStyle`
  .empresa-multiselect-dropdown .ant-select-item-option-content {
    white-space: normal;
    word-break: break-word;
  }
`;